<template>
    <adjustments-table></adjustments-table>
</template>

<script>
import AdjustmentsTable from '../components/Results/AdjustmentsTable'
import { mapGetters, mapActions, mapMutations } from 'vuex';

export default {
    components: {
        AdjustmentsTable
    },
    computed: {
        ...mapGetters(["getScenario"]),
    },
    methods: {
        ...mapActions(["fetchScenario"]),
        ...mapMutations(["setSelectedLoanId"])
    },
    mounted() {
        if (this.getScenario.id === null) {
            this.setSelectedLoanId(this.$route.params.id);
            this.fetchScenario({ scenario: "haloScenario" });
        }
    },
}
</script>